import React, { useContext, useEffect } from 'react';
import AuthContext from '../../context/AuthProvider';
import { RouterPrivate, RouterPublic } from './Routes';
import { getURLParams } from '../../helpers/HelpersFunctions';
import { useNavigate } from 'react-router-dom';

const Router = () => {
  const { datalogin } = useContext(AuthContext);
  let navigate = useNavigate();

  const params = getURLParams();

  useEffect(() => {
    if (params) {
      setTimeout(() => {
        navigate(params);
      }, 1);
    }
  }, [datalogin]);

  return <>{datalogin ? <RouterPrivate /> : <RouterPublic />}</>;
};

export default Router;
